import { apiGet, apiPatch } from './client';
import type {
  CreationRedemption,
  CreationRedemptionBatchRequest,
} from '../types/CreationRedemption';

// Tenant-scoped (X-Tenant-Id applied automatically by the client).
export function getCreationRedemptions(): Promise<CreationRedemption[]> {
  return apiGet<CreationRedemption[]>('/api/creation-redemptions');
}

export function saveCreationRedemptionsBatch(
  added: CreationRedemption[],
  modified: CreationRedemption[],
  deletedIds: number[],
): Promise<CreationRedemption[]> {
  return apiPatch<CreationRedemptionBatchRequest, CreationRedemption[]>(
    '/api/creation-redemptions/batch',
    {
      added,
      modified,
      deleted: deletedIds,
    },
  );
}
